import * as React from 'react'
import { TeamSettingsMainConnected } from './TeamSettingsMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TeamSettingsMainExamples = () => {
  return (
    <div className="TeamSettingsMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TeamSettingsMainConnected />
      </Provider>
    </div>
  )
}
